import { FOOTAGE_UPLOAD_CONTENT_TYPES, FOOTAGE_UPLOAD_MAX_BYTES } from 'fym-shared/src/music24/musicVideoApi';
import type { FootageUploadError } from '../doc/musicVideoErrors';

/** The type of a file: the browser type, else from the extension (some systems give no type for MOV). Pure. */
export function footageContentType(file: { name: string; type: string }): string | null {
  const allowed: readonly string[] = FOOTAGE_UPLOAD_CONTENT_TYPES;
  if (allowed.includes(file.type)) {
    return file.type;
  }
  const lower = file.name.toLowerCase();
  if (lower.endsWith('.mp4') || lower.endsWith('.m4v')) {
    return 'video/mp4';
  }
  if (lower.endsWith('.mov')) {
    return 'video/quicktime';
  }
  return null;
}

/** The check before the upload starts: the type and the cap of spec §4.3. Pure. */
export function footageFileRefusal(file: { name: string; type: string; size: number }): FootageUploadError | null {
  if (footageContentType(file) === null) {
    return 'type';
  }
  if (file.size > FOOTAGE_UPLOAD_MAX_BYTES) {
    return 'tooLarge';
  }
  return null;
}
